import { PriceCalculationResponseEntity } from "Store/priceCalculation/priceCalculationInterfaces";
import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";

export const useGetPriceCalculationResultLoadingState =
  (): PriceCalculationResponseEntity["isLoading"] => {
    const { isLoading } = useSelector(
      (state: ReduxState) => state.priceCalculation.priceCalculationResult,
    );
    return isLoading;
  };
